import React, { lazy } from 'react';
import { Gift } from 'lucide-react';
export function BonusSection() {
  return <section className="py-20 bg-amber-50 relative" data-id="element-13">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-14">
        <div className="text-center mb-16" data-id="element-15">
          <div className="inline-flex items-center justify-center bg-red-600 text-white font-black px-6 py-2 rounded-full mb-6 text-lg animate-pulse shadow-lg" data-id="element-16">
            🔥 GRATIS POR HOY 🔥
          </div>
          <h2 className="text-4xl md:text-5xl font-extrabold text-[#1E3A5F] mb-4 flex items-center justify-center" data-id="element-17">
            <Gift className="w-10 h-10 mr-4 text-[#F59E0B]" data-id="element-18" />
            BONOS INCLUIDOS HOY
          </h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto" data-id="element-19">
            Llevate estas 3 herramientas exclusivas sin costo adicional si
            completás tu pedido hoy.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-20">
          {/* Bono 1 */}
          <div className="bg-white rounded-3xl p-8 shadow-xl border-2 border-amber-200 relative transform transition duration-300 hover:-translate-y-2" data-id="element-21">
            <div className="absolute -top-5 -right-5 bg-red-500 text-white font-bold px-4 py-1 rounded-full shadow-md transform rotate-12" data-id="element-22">
              GRATIS
            </div>

            <div className="flex justify-center mb-6" data-id="element-23">
              <img src="https://cdn.magicpatterns.com/uploads/vTsERL1YG2XhS3MS1ksVe9/bono_1.png" alt="Bono 1 - Banco de Consignas Inteligentes" loading="lazy" className="w-48 h-auto drop-shadow-2xl" data-id="element-24" />
            </div>

            <h3 className="text-xl font-bold text-[#1E3A5F] mb-2" data-id="element-25">
              🎁 Bono #1:
            </h3>
            <h4 className="text-2xl font-extrabold text-[#F59E0B] mb-4 leading-tight" data-id="element-26">
              Banco de Consignas Inteligentes
            </h4>
            <p className="text-slate-700 font-medium mb-6" data-id="element-27">
              150 preguntas organizadas por nivel listas para usar con cualquier
              lectura.
            </p>
            <ul className="space-y-3 mb-6" data-id="element-28">
              <li className="flex items-start text-sm text-slate-600" data-id="element-29">
                <span className="text-[#16A34A] mr-2" data-id="element-30">✔</span> Consignas para
                1º y 2º / 3º y 4º / 5º y 6º
              </li>
              <li className="flex items-start text-sm text-slate-600" data-id="element-31">
                <span className="text-[#16A34A] mr-2" data-id="element-32">✔</span> 30 preguntas
                comodín para cualquier texto
              </li>
              <li className="flex items-start text-sm text-slate-600" data-id="element-33">
                <span className="text-[#16A34A] mr-2" data-id="element-34">✔</span> 24 disparadores
                de escritura de 5 minutos
              </li>
              <li className="flex items-start text-sm text-slate-600" data-id="element-35">
                <span className="text-[#16A34A] mr-2" data-id="element-36">✔</span> Mini guía para
                elegir la consigna según tu objetivo
              </li>
            </ul>
            <div className="bg-amber-50 p-4 rounded-xl border border-amber-100" data-id="element-37">
              <p className="text-sm font-bold text-[#1E3A5F] italic" data-id="element-38">
                Para que nunca más te quedes en blanco después de una lectura.
              </p>
            </div>
          </div>

          {/* Bono 2 */}
          <div className="bg-white rounded-3xl p-8 shadow-xl border-2 border-amber-200 relative transform transition duration-300 hover:-translate-y-2" data-id="element-39">
            <div className="absolute -top-5 -right-5 bg-red-500 text-white font-bold px-4 py-1 rounded-full shadow-md transform rotate-12" data-id="element-40">
              GRATIS
            </div>

            <div className="flex justify-center mb-6" data-id="element-41">
              <img src="https://cdn.magicpatterns.com/uploads/evYDTsRhU2jgeBQ4JHT8jG/heylloyd-image-1773339182851.png" alt="Bono 2 - Kit de Emergencia 15 Minutos de Lengua" loading="lazy" className="w-48 h-auto drop-shadow-2xl" data-id="element-42" />
            </div>

            <h3 className="text-xl font-bold text-[#1E3A5F] mb-2" data-id="element-43">
              🎁 Bono #2:
            </h3>
            <h4 className="text-2xl font-extrabold text-[#F59E0B] mb-4 leading-tight" data-id="element-44">
              Kit de Emergencia - 15 Minutos de Lengua
            </h4>
            <p className="text-slate-700 font-medium mb-6" data-id="element-45">
              58 herramientas para los días que nada sale como planeaste.
            </p>
            <ul className="space-y-3 mb-6" data-id="element-46">
              <li className="flex items-start text-sm text-slate-600" data-id="element-47">
                <span className="text-[#16A34A] mr-2" data-id="element-48">✔</span> 25 actividades
                sin fotocopias (solo pizarrón y cuaderno)
              </li>
              <li className="flex items-start text-sm text-slate-600" data-id="element-49">
                <span className="text-[#16A34A] mr-2" data-id="element-50">✔</span> 10 juegos
                silenciosos para días de desorden
              </li>
              <li className="flex items-start text-sm text-slate-600" data-id="element-51">
                <span className="text-[#16A34A] mr-2" data-id="element-52">✔</span> 8 rutinas de
                lectura express para arrancar la clase
              </li>
              <li className="flex items-start text-sm text-slate-600" data-id="element-53">
                <span className="text-[#16A34A] mr-2" data-id="element-54">✔</span> Plan B para
                cuando no hay copias
              </li>
            </ul>
            <div className="bg-amber-50 p-4 rounded-xl border border-amber-100 mt-auto" data-id="element-55">
              <p className="text-sm font-bold text-[#1E3A5F] italic" data-id="element-56">
                Para el día que la fotocopiadora se rompe o llegaste tarde y no
                preparaste nada.
              </p>
            </div>
          </div>

          {/* Bono 3 */}
          <div className="bg-white rounded-3xl p-8 shadow-xl border-2 border-amber-200 relative transform transition duration-300 hover:-translate-y-2" data-id="element-57">
            <div className="absolute -top-5 -right-5 bg-red-500 text-white font-bold px-4 py-1 rounded-full shadow-md transform rotate-12" data-id="element-58">
              GRATIS
            </div>

            <div className="flex justify-center mb-6" data-id="element-59">
              <img src="https://cdn.magicpatterns.com/uploads/3n43nTm8nsfUXjZEihCnGr/heylloyd-image-1773339294301.png" alt="Bono 3 - El Escudo Escolar" loading="lazy" className="w-48 h-auto drop-shadow-2xl" data-id="element-60" />
            </div>

            <h3 className="text-xl font-bold text-[#1E3A5F] mb-2" data-id="element-61">
              🎁 Bono #3:
            </h3>
            <h4 className="text-2xl font-extrabold text-[#F59E0B] mb-4 leading-tight" data-id="element-62">
              El Escudo Escolar
            </h4>
            <p className="text-slate-700 font-medium mb-6" data-id="element-63">
              Sistema de seguimiento para protegerte frente a padres y
              directivos.
            </p>
            <ul className="space-y-3 mb-6" data-id="element-64">
              <li className="flex items-start text-sm text-slate-600" data-id="element-65">
                <span className="text-[#16A34A] mr-2" data-id="element-66">✔</span> Ficha individual
                por alumno con 3 cortes anuales
              </li>
              <li className="flex items-start text-sm text-slate-600" data-id="element-67">
                <span className="text-[#16A34A] mr-2" data-id="element-68">✔</span> Planilla grupal
                para 30 alumnos
              </li>
              <li className="flex items-start text-sm text-slate-600" data-id="element-69">
                <span className="text-[#16A34A] mr-2" data-id="element-70">✔</span> Rúbrica de 4
                niveles de comprensión lectora
              </li>
              <li className="flex items-start text-sm text-slate-600" data-id="element-71">
                <span className="text-[#16A34A] mr-2" data-id="element-72">✔</span> Informe
                trimestral para padres listo para imprimir y firmar
              </li>
              <li className="flex items-start text-sm text-slate-600" data-id="element-73">
                <span className="text-[#16A34A] mr-2" data-id="element-74">✔</span> 24 frases listas
                para boletines e informes
              </li>
            </ul>
            <div className="bg-amber-50 p-4 rounded-xl border border-amber-100" data-id="element-75">
              <p className="text-sm font-bold text-[#1E3A5F] italic" data-id="element-76">
                Para que cuando un padre te pregunte "¿cómo lee mi hijo?" tengas
                la respuesta escrita, firmada y sellada.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}